window.jQuery = window.$ = require('jquery');
let $ = require('jquery');
let isMobile = require('ismobilejs');
//let IScroll = require('iscroll');

// googlemap
//import './vendor/googlemap.js';
//import './vendor/googlemap.acf.js';

$(function() {

  // top page
  const topBtn = $('.s-footer__pagetop');
  topBtn.click(function() {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });


  // faq
  $('.open_faq').click(function () {

    var h = $(window).innerHeight();
    var w = $(window).innerWidth() / 2;

    var y = $(window).scrollTop() - h;

    $('.s-company-faq').show();
    $('#layer').show();
    $('html').css('overflow', 'hidden');

    return false;
  });

  $('.close_faq').click(function() {
    $('.s-company-faq').css('top', 0).hide();
    $('#layer').hide();
    $('html').css('overflow', 'auto');

    return false;
  });

  function setAddress(target) {
    if ($(target).val() == 1) {
      $('input[name="customer_address"]').prop('disabled', false);
      $('input[name="customer_address"]').removeClass('disabled');
    } else {
      $('input[name="customer_address"]').val('');
      $('input[name="customer_address"]').prop("disabled", true);
      $('input[name="customer_address"]').addClass('disabled');
    }
  }
  $('input[name="check_category"]').change(function() {
    setAddress(this);
  });
  if ($('.s-company__confirm').size() == 0) {
    setAddress('input[name="check_category"]:checked');
  }

  // top menu 
  if ($('.s-index').size() > 0) {
    var scrollflg = true;

    var target;

    function setFixed(win) {
      if($(win).scrollTop() >= target) {
        if ($('nav').hasClass('fixed') == false) {
          $('nav').addClass('fixed');
        }
      } else {
        $('nav').removeClass('fixed');
      }
    }

    $(window).on('load resize', function() {
      var windowWidth = window.innerWidth;

      if (windowWidth > 1024) {

        // PCの処理
        target = $('nav').offset().top - $('.s-header__topbar').height();

      } else if (windowWidth > 768) {

        // TABの処理
        target = $('nav').offset().top - $('.s-header__topbar').height();

      } else {

        // SPの処理
        target = $('nav').offset().top;
      }

      setFixed(this);
    });

    $(window).scroll(function(){
      if (scrollflg) {
        scrollflg = false;
        setTimeout(function() {

          setFixed(this);
            
          scrollflg = true;
          return scrollflg;
        }, 1);
      }
    });
  }

  function isPhone() {
      return (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0);
  }

  if (isPhone()) {
    $('span[data-action=call]').each(function() {
      var $ele = $(this);
      $ele.wrap('<a href="tel:' + $ele.data('tel') + '"></a>');
    });
  }
});

import 'jquery-lazyload';
$(function() {
  $('.lazy').lazyload({
    threshold: 200
//    effect: 'fadeIn'
  });
});

/*
// Infinyty Scroll
import './vendor/jquery.clever-infinite-scroll.js';
$(function() {
  // const windowHeight = $(window).height();
  $('.s-content').cleverInfiniteScroll({
    contentsWrapperSelector: '.s-content',
    contentSelector: '.l-article',
    nextSelector: '.l-article__next',
    loadImage: '/images/loading.gif'
  });
//  $(window).on('cis', function() {
//    set_map();
//  });
});
*/

import 'scroll-depth';
$(function() {
  $.scrollDepth({
//    minHeight: 2000,
    elements: ['.s-index', '.s-highquality', '.s-pricelist', '.s-information', '.s-company', '.footer'],
    percentage: false,
    pixelDepth: false
  });
});




// WEBPACK FOOTER //
// ./src/assets/javascripts/shared.js